import React, { Component } from "react";
import styled from "styled-components";
import { Form, Formik } from "formik";
import FieldsCommon from "./FieldsCommon";
import FieldsRaquet from "./FieldsRaquet/FieldsRaquet";
import FieldsBasketball from "./FieldsBasketball/FieldsBasketball";
import FieldsMultisport from "./FieldsMultisport";
import { connect } from "react-redux";
import {
  COMMON_INITIAL_VALUES,
  FIELD_TYPES,
  INITIAL_VALUES,
} from "../constants";
import ConditionalComponent from "./ConditionalComponent";

const Formed = styled(Form)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 280px));
  grid-auto-rows: minmax(min-content, max-content);
  justify-content: center;
  align-items: start;
  grid-gap: 25px;
  width: 100%;
  height: 250px;
  font-size: 12px;
  fieldset {
    border: none;
    margin: 0;
    padding: 0;
  }
  h2 {
    padding-bottom: 8px;
    border-bottom: 2px solid #000;
  }
  @media (max-width: 1200px) {
    height: 440px;
    width: 75%;
    grid-template-columns: 1fr 1fr;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    height: auto;
  }
`;

class FieldSettings extends Component {
  onSubmit = data => {
    this.props.dispatch.field.setOptions(data);
    return {};
  };

  constructor(props) {
    super(props);
    const { type } = this.props.field;
    const initialValues = { ...INITIAL_VALUES[type], ...COMMON_INITIAL_VALUES };
    this.initialValues = initialValues;
    this.onSubmit(initialValues);
  }

  render() {
    const { onSubmit, initialValues } = this;
    return (
      <div>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validate={onSubmit}
          enableReinitialize={true}
        >
          <Formed>
            <ConditionalComponent component={FieldsBasketball} />
            <ConditionalComponent
              component={FieldsRaquet}
              conditions={{
                minX: 20,
              }}
            />
            <FieldsCommon />
            <ConditionalComponent
              component={FieldsMultisport}
              conditions={{ fieldType: FIELD_TYPES.multisport }}
            />
          </Formed>
        </Formik>
      </div>
    );
  }
}

const mapState = ({ field }) => ({ field });
export default connect(mapState)(FieldSettings);
